let online = true;
const waiters = new Set<() => void>();

export const setNetworkOnline = (isOnline: boolean): void => {
  online = isOnline;
  if (isOnline) [...waiters].forEach(release => release());
};

export const isNetworkOnline = (): boolean => online;

/** Resolves once the network status is online, or when `signal` aborts. */
export const whenOnline = (signal: AbortSignal): Promise<void> =>
  new Promise(resolve => {
    if (online || signal.aborted) {
      resolve();
      return;
    }
    const release = () => {
      waiters.delete(release);
      signal.removeEventListener('abort', release);
      resolve();
    };
    waiters.add(release);
    signal.addEventListener('abort', release);
  });
